import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveIndustry = async (industry, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        let Payload = {
            industryID: industry.industryID,
            industryName: industry.industryName,
            rate: industry.rate,
            isActive: industry.isActive
        };
  
        const response = await fetch(`${dev_baseUrl}/Service/saveIndustry`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(Payload),
        });
  
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
      } catch (error) {
        console.error("Network error:", error);
        return {
          isError: true,
          message: "An error occurred. Please try again later.",
          error: error,
        };
      }
    } else {
      console.warn("Access token is not available.");
      return { form: "Access token is missing." };
    }
  };
